import { api } from "@/api/axios.ts";
import { ApiOperationResult } from "@/types/common.types.ts";
import { ApiWorkPattern, ApiWorkPatternPayload } from "@/types/work-pattern.types.ts";

export const apiWorkPatterns = {
  getAll: () => {
    return api.get<ApiWorkPattern[]>("/api/v1/work-patterns");
  },
  create: (payload: ApiWorkPatternPayload) => {
    return api.post<ApiWorkPattern>("/api/v1/work-patterns", payload);
  },
  update: (id: number, payload: ApiWorkPatternPayload) => {
    return api.put<ApiWorkPattern>(`/api/v1/work-patterns/${id}`, payload);
  },
  delete: (id: number) => {
    return api.delete<ApiOperationResult>(`/api/v1/work-patterns/${id}`);
  },
};
